import PropTypes from 'prop-types';

const ForbiddenIllustration = ({ className }) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 480 360"
        className="w-full h-full"
      >
        <defs>
          <linearGradient id="BG" x1="19.496%" x2="77.479%" y1="71.822%" y2="16.69%">
            <stop offset="0%" stopColor="#0CA37F" />
            <stop offset="100%" stopColor="#1C7F66" />
          </linearGradient>
        </defs>
        <path
          fill="url(#BG)"
          fillRule="nonzero"
          d="M0 198.78c0 41.458 14.945 79.236 39.539 107.786 28.214 32.765 69.128 53.365 114.734 53.434a148.44 148.44 0 0056.495-11.036c9.051-3.699 19.182-3.274 27.948 1.107a75.779 75.779 0 0033.957 8.01c5.023 0 9.942-.494 14.7-1.433 13.58-2.67 25.94-8.99 36.09-17.94 6.378-5.627 14.547-8.456 22.897-8.446h.142c27.589 0 53.215-8.732 74.492-23.696 19.021-13.36 34.554-31.696 44.904-53.224C474.92 234.58 480 213.388 480 190.958c0-76.93-59.774-139.305-133.498-139.305-7.516 0-14.88.663-22.063 1.899C305.418 21.42 271.355 0 232.499 0a103.651 103.651 0 00-45.88 10.661c-13.24 6.487-25.011 15.705-34.64 26.939-30.63-17.566-65.14-27.516-101.833-27.516C22.498 10.084 0 32.928 0 61.379v137.401z"
          opacity="0.2"
        />
        <path
          fill="#FFAB00"
          d="M292.4 148.8l-56.32 56.32c-3.007 3.008-7.205 4.422-11.28 3.851l-55.32-7.52c-6.904-.96-12.24-6.542-12.8-13.6l-7.52-55.2c-.639-4.206 1.061-8.405 4.56-11.04l56.24-56.32c7.145-7.145 18.641-7.736 26.4-1.36l58.48 47.76c7.377 6.057 8.801 16.883 3.36 24.64l-5.8 12.47z"
          opacity="0.12"
        />
        <path
          fill="#FFD666"
          d="M299.36 157.52l-56.32 56.32c-3.007 3.008-7.205 4.422-11.28 3.851l-55.2-7.52c-6.904-.96-12.24-6.542-12.8-13.6l-7.52-55.2c-.639-4.206 1.061-8.405 4.56-11.04l56.24-56.32c7.145-7.145 18.641-7.736 26.4-1.36l58.48 47.76c7.377 6.057 8.801 16.883 3.36 24.64l-5.92 12.47z"
          opacity="0.24"
        />
        <path
          fill="#FFC107"
          d="M306.32 166.24l-56.32 56.32c-3.007 3.008-7.205 4.422-11.28 3.851l-55.2-7.52c-6.904-.96-12.24-6.542-12.8-13.6l-7.52-55.2c-.639-4.206 1.061-8.405 4.56-11.04l56.24-56.32c7.145-7.145 18.641-7.736 26.4-1.36l58.48 47.76c7.377 6.057 8.801 16.883 3.36 24.64l-5.92 12.47z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M213.2 128l-28.8 28.8 28.8 28.8-11.2 11.2-28.8-28.8-28.8 28.8-11.2-11.2 28.8-28.8-28.8-28.8 11.2-11.2 28.8 28.8 28.8-28.8 11.2 11.2z"
        />
        <path
          fill="#FFA000"
          fillRule="nonzero"
          d="M257.04 286.4l-56.32 56.32c-3.007 3.008-7.205 4.422-11.28 3.851l-55.2-7.52c-6.904-.96-12.24-6.542-12.8-13.6l-7.52-55.2c-.639-4.206 1.061-8.405 4.56-11.04l56.24-56.32c7.145-7.145 18.641-7.736 26.4-1.36l58.48 47.76c7.377 6.057 8.801 16.883 3.36 24.64l-5.92 12.47z"
          opacity="0.24"
        />
        <path
          fill="#FFC107"
          fillRule="nonzero"
          d="M248.96 277.76l-56.32 56.32c-3.007 3.008-7.205 4.422-11.28 3.851l-55.2-7.52c-6.904-.96-12.24-6.542-12.8-13.6l-7.52-55.2c-.639-4.206 1.061-8.405 4.56-11.04l56.24-56.32c7.145-7.145 18.641-7.736 26.4-1.36l58.48 47.76c7.377 6.057 8.801 16.883 3.36 24.64l-5.92 12.47z"
          opacity="0.24"
        />
        <path
          fill="#FFD666"
          fillRule="nonzero"
          d="M240.88 269.12l-56.32 56.32c-3.007 3.008-7.205 4.422-11.28 3.851l-55.2-7.52c-6.904-.96-12.24-6.542-12.8-13.6l-7.52-55.2c-.639-4.206 1.061-8.405 4.56-11.04l56.24-56.32c7.145-7.145 18.641-7.736 26.4-1.36l58.48 47.76c7.377 6.057 8.801 16.883 3.36 24.64l-5.92 12.47z"
          opacity="0.32"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M168.96 230.4l-28.8 28.8 28.8 28.8-11.2 11.2-28.8-28.8-28.8 28.8-11.2-11.2 28.8-28.8-28.8-28.8 11.2-11.2 28.8 28.8 28.8-28.8 11.2 11.2z"
        />
        <circle cx="368" cy="128" r="64" fill="#0CA37F" opacity="0.16" />
        <circle cx="368" cy="128" r="48" fill="#0CA37F" opacity="0.24" />
        <circle cx="368" cy="128" r="32" fill="#0CA37F" opacity="0.32" />
        <circle cx="368" cy="128" r="16" fill="#0CA37F" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M368 120c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 36c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22zm0-8c-7.732 0-14-6.268-14-14s6.268-14 14-14 14 6.268 14 14-6.268 14-14 14z"
        />
      </svg>
    </div>
  );
};

ForbiddenIllustration.propTypes = {
  className: PropTypes.string
};

export default ForbiddenIllustration;
